"use strict";

(function () {
  'use strict';

  angular.module('app.services', ['utils-service', 'auth-service', 'login-service', 'trip-service', 'payment-service', 'account-service', 'connections-service', 'date-service', 'ga.service.analytics']);
})();